import SubscriptionConsumptionSummaryRequest from "interfaces/request/SubscriptionConsumptionSummaryRequest";
import DailyConsumptionSummary from "interfaces/response/DailyConsumptionSummary";
import { generateQueryParam } from "shared/utility/ApiUtility";
import { getDataAsync } from "./PortalApi";

export const getSubscriptionConsumptionSummaryByDayAsync = async (
  request: SubscriptionConsumptionSummaryRequest
) => {
  let url = `Subscriptions/${request.subscriptionId}/Consumptions/ByDay`;

  var queryParam = generateQueryParam([
    {
      key: "fromDate",
      value: request.fromDate,
    },
    {
      key: "toDate",
      value: request.toDate,
    },
    {
      key: "tags",
      value: request.tags,
    },
  ]);

  if (queryParam) {
    url = `${url}${queryParam}`;
  }

  return await getDataAsync<DailyConsumptionSummary[]>(url);
};
